<template>
    <div class="sip-image-upload">
        <file-dropzone
            v-if="!disabledInput"
            ref="dropzone"
            :id="id"
            :button-text="buttonText"
            accept=".jpg,.jpeg,.png,.gif,.pdf,image/*"
            :existing-preview="dropzonePreview"
            :existing-name="existingLabel"
            @change="previewImage"
        />
        <div v-else-if="dropzonePreview" class="sip-file-dropzone sip-file-dropzone--readonly">
            <div class="sip-file-dropzone__body">
                <div class="sip-file-dropzone__thumb">
                    <img :src="dropzonePreview" alt="" @error="onImageError">
                </div>
            </div>
        </div>
        <p v-if="imageLoadError" class="text-soft small mt-2">{{ trans('general.image_load_failed') || 'Image could not be loaded.' }}</p>
        <div class="sip-image-upload__pdf" v-if="isPdfCurrent">
            <a target="_blank" :href="pdfHref">{{ trans('general.view') }}</a>
        </div>
        <div class="sip-image-upload__actions" v-if="!disabledInput">
            <button type="button" class="btn btn-sm btn-danger" v-if="defaultImage && !source" v-confirm="{ok: confirmRemove(imageSource)}">{{trans('general.remove')}}</button>
            <button type="button" class="btn btn-sm btn-primary" v-if="source" @click="uploadImage">{{trans('general.upload')}}</button>
            <button type="button" class="btn btn-sm btn-danger" v-if="source" @click="cancelUploadImage">{{trans('general.cancel_upload')}}</button>
        </div>
    </div>
</template>

<script>
    import fileDropzone from './file-dropzone.vue'

    export default {
        components: { fileDropzone },
        props: {
            id: {
                default: ''
            },
            uploadPath: {
                required: true
            },
            removePath: {
                required: true
            },
            imageSource: {
                default: ''
            },
            buttonText: {
                default: i18n.general.choose_image
            },
            disabledInput: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                source: '',
                uploaded: '',
                isRemoved: false,
                image: '',
                imageLoadError: false,
                selectedFile: null
            }
        },
        methods: {
            getInputFile() {
                if (this.selectedFile) {
                    return this.selectedFile;
                }
                if (this.id && window.$) {
                    const el = $('#'+this.id)[0];
                    if (el && el.files && el.files[0]) {
                        return el.files[0];
                    }
                }
                if (this.$refs.dropzone && this.$refs.dropzone.$refs.input) {
                    const files = this.$refs.dropzone.$refs.input.files;
                    if (files && files[0]) {
                        return files[0];
                    }
                }
                return null;
            },
            previewImage(e) {
                let files = (e && e.target && e.target.files) || (e && e.dataTransfer && e.dataTransfer.files);
                let file = (files && files[0]) || this.getInputFile();
                if (!file) {
                    return;
                }
                let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
                if(!allowedExtensions.exec(file.name)) {
                    NioApp.Toast(i18n.general.file_not_supported, 'error');
                    this.cancelUploadImage();
                    return;
                }
                this.selectedFile = file;
                this.createImage(file);
            },
            createImage(file) {
                let reader = new FileReader();
                reader.onload = (e) => {
                    this.source = e.target.result;
                };
                reader.readAsDataURL(file);
            },
            cancelUploadImage(){
                this.source = '';
                this.selectedFile = null;
                if (this.$refs.dropzone && this.$refs.dropzone.clear) {
                    this.$refs.dropzone.clear();
                }
                if (this.id && window.$) {
                    $("#"+this.id).val('');
                }
            },
            uploadImage() {
                let file = this.getInputFile();
                if (!file) {
                    return;
                }
                let loader = this.$loading.show();
                let data = new FormData();

                if(file.size > helper.getConfig('post_max_size')){
                    NioApp.Toast(i18n.general.file_too_large, 'error');
                    loader.hide();
                    return;
                }

                data.append('image', file);
                axios.post('/api'+this.uploadPath,data)
                    .then(response => {
                        NioApp.Toast(response.message, 'success');
                        this.source = '';
                        this.selectedFile = null;
                        this.uploaded = response.image;
                        this.imageLoadError = false;
                        this.isRemoved = false;
                        this.$emit('uploaded',response.image);
                        if (this.$refs.dropzone && this.$refs.dropzone.clear) {
                            this.$refs.dropzone.clear();
                        }
                        if (this.id && window.$) {
                            $("#"+this.id).val('');
                        }
                        loader.hide();
                    }).catch(error => {
                        loader.hide();
                        if(error.response.errors && error.response.errors.hasOwnProperty("message")){
                            NioApp.Toast(error.response.errors.message[0], 'error');
                        } else if(error.response.status == 422) {
                            NioApp.Toast(error.response.error, 'error');
                            this.cancelUploadImage();
                        }
                        else if(error.response.status == 413 || error.response.status == 500){
                            NioApp.Toast(i18n.general.file_too_large, 'error');
                            this.cancelUploadImage();
                        }
                        else
                            helper.showErrorMsg(error);
                    });
            },
            onImageError() {
                this.imageLoadError = true;
            },
            confirmRemove(imageSource){
                return dialog => this.removeImage();
            },
            removeImage() {
                let loader = this.$loading.show();
                axios.delete('/api'+this.removePath)
                    .then(response => {
                        NioApp.Toast(response.message, 'success');
                        this.isRemoved = true;
                        this.uploaded = '';
                        this.source = '';
                        this.selectedFile = null;
                        this.$emit('removed','');
                        loader.hide();
                    }).catch(error => {
                        loader.hide();
                        if(error.response.errors.hasOwnProperty("message")){
                            NioApp.Toast(error.response.errors.message[0], 'error');
                        } else if(error.response.status == 422) {
                            NioApp.Toast(error.response.error, 'error');
                            this.cancelUploadImage();
                        }
                        else {
                            helper.showErrorMsg(error);
                        }
                    });
            }
        },
        computed: {
            defaultImage(){
                return ((this.imageSource && !this.isRemoved) || this.uploaded) ? true : false;
            },
            getImage(){
                const path = (this.uploaded || this.imageSource || '').replace(/^\/+/, '');
                if (!path) return '';
                if (typeof window !== 'undefined' && window.location.origin) {
                    if (this.uploadPath && (this.imageSource || this.uploaded) && this.uploadPath.includes('/configuration/logo_dark'))
                        return helper.getDarkLogo();
                    if (this.uploadPath && (this.imageSource || this.uploaded) && this.uploadPath.includes('/configuration/logo'))
                        return helper.getLogo();
                    if (this.uploadPath && (this.imageSource || this.uploaded) && this.uploadPath.includes('/configuration/icon'))
                        return helper.getIcon();
                    return helper.getImageUrl(path);
                }
                return '/' + path;
            },
            isPdfCurrent(){
                const src = this.source || this.getImage || '';
                return src.includes('.pdf');
            },
            pdfHref(){
                return this.getImage || this.source || '';
            },
            dropzonePreview(){
                if (this.source && !this.source.includes('.pdf')) {
                    return this.source;
                }
                if (this.defaultImage && this.getImage && !this.getImage.includes('.pdf')) {
                    return this.getImage;
                }
                return '';
            },
            existingLabel(){
                if (this.source && this.selectedFile) {
                    return this.selectedFile.name;
                }
                if (this.defaultImage && !this.source) {
                    return (this.trans && this.trans('general.current_file')) || 'Current file';
                }
                return '';
            }
        },
        watch: {
            imageSource() { this.imageLoadError = false; },
            uploaded() { this.imageLoadError = false; }
        }
    }
</script>
